export function initLocationTabs(root = document) {
    root.querySelectorAll('[data-js="location-tabs"]').forEach((container) => {
        const tabs = Array.from(container.querySelectorAll('[data-js="location-tab"]'));
        const panels = Array.from(container.querySelectorAll('[data-js="location-tabpanel"]'));

        if (!tabs.length || !panels.length) return;

        const activate = (tab, { focus = false } = {}) => {
            tabs.forEach((t) => {
                const selected = t === tab;

                t.setAttribute('aria-selected', String(selected));
                t.setAttribute('tabindex', selected ? '0' : '-1');
                t.classList.toggle('location__tab--active', selected);
            });

            panels.forEach((panel) => {
                panel.hidden = panel.id !== tab.getAttribute('aria-controls');
            });

            if (focus) tab.focus();
        };

        tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => activate(tab));

            tab.addEventListener('keydown', (event) => {
                let next = null;

                switch (event.key) {
                    case 'ArrowRight':
                        next = tabs[(index + 1) % tabs.length];
                        break;
                    case 'ArrowLeft':
                        next = tabs[(index - 1 + tabs.length) % tabs.length];
                        break;
                    case 'Home':
                        next = tabs[0];
                        break;
                    case 'End':
                        next = tabs[tabs.length - 1];
                        break;
                    default:
                        return;
                }

                event.preventDefault();
                activate(next, { focus: true });
            });
        });
    });
}

// Uso: initLocationTabs();
